import angular from 'angular';
import infrastructureOptionDirective from './infrastructure-option.directive';


export default angular.module('app.components.advisory.enterpriseModeling.infrastructureOption', [])
  .directive('emInfrastructureOption', infrastructureOptionDirective)
  .controller('InfrastructureOptionController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.enterpriseModeling.infrastructureOption created');
